import React, {useEffect} from 'react';

const MetaTags = () => {
    useEffect(() => {
        let link = document.createElement('link');
        link.rel = "alternate";
        link.setAttribute('hrefLang', 'en-GB')
        link.href = window.raeEnv.oktaLoginUrl;
        document.getElementsByTagName('head')[0].appendChild(link);
    }, []);
    return <></>
};

export default MetaTags;